// src/pages/authn/AuthnSettingsPage.tsx
// Auto-generated by corebuilder. Edit freely.

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { observer } from '@react';
import { useAuthn, useI18n } from '@react/hooks';
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
  Alert,
  ErrorAlert,
} from '@react/components';
import { ToggleSwitch } from '@/components/ToggleSwitch';

/**
 * Authn settings page.
 * Features:
 * - i18n via useI18n hook
 * - Semantic color tokens (theme-aware, dark mode ready)
 * - Customize with service-specific settings
 */
export const AuthnSettingsPage = observer(() => {
  const store = useAuthn();
  const { t } = useI18n();
  const [saved, setSaved] = useState(false);
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [pushNotifications, setPushNotifications] = useState(true);
  const [compactList, setCompactList] = useState(true);
  const [advancedFields, setAdvancedFields] = useState(false);

  const handleSave = async () => {
    // TODO: Implement settings save logic
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="space-y-6">
      {/* The tab already names this page; the heading stays for screen readers. */}
      <div>
        <nav className="text-sm">
          <Link to="/authns" className="text-muted-foreground hover:text-foreground">
            {t('authn.list')}
          </Link>
          <span className="mx-2 text-muted-foreground">/</span>
          <span className="text-foreground">{t('authn.settings')}</span>
        </nav>
        <h1 className="sr-only">{t('authn.settings')}</h1>
      </div>

      {/* Success notification */}
      {saved && (
        <Alert variant="success" dismissible onDismiss={() => setSaved(false)}>
          {t('authn.saveSuccess')}
        </Alert>
      )}

      {/* Error state */}
      {store.error ? <ErrorAlert error={store.error} dismissible onDismiss={() => store.clearError()} /> : null}

      {/* Notification Preferences */}
      <Card>
        <CardHeader>
          <CardTitle>Notification Preferences</CardTitle>
          <CardDescription>Choose how you want to be notified about authn events.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* TODO: Add notification preference toggles */}
          <ToggleSwitch label="Email notifications" checked={emailNotifications} onChange={setEmailNotifications} />
          <ToggleSwitch label="Push notifications" checked={pushNotifications} onChange={setPushNotifications} />
        </CardContent>
      </Card>

      {/* Display Preferences */}
      <Card>
        <CardHeader>
          <CardTitle>Display Preferences</CardTitle>
          <CardDescription>Customize how authn data is displayed.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* TODO: Add display preference controls */}
          <ToggleSwitch label="Compact list view" checked={compactList} onChange={setCompactList} />
          <ToggleSwitch label="Advanced fields" checked={advancedFields} onChange={setAdvancedFields} />
        </CardContent>
        <CardFooter className="flex justify-end">
          <Button onClick={handleSave}>{t('common.save')}</Button>
        </CardFooter>
      </Card>
    </div>
  );
});

export default AuthnSettingsPage;
